import React from 'react';
import { BsFileEarmarkExcelFill, BsFileEarmarkPdfFill, BsFileEarmarkFill } from 'react-icons/bs';

const FILE_BUTTON_STYLE = {
  backgroundColor: '#068f7a',
  borderColor: '#068f7a',
  color: '#ffffff',
};

function FilePreview({ filePath }) {
  if (!filePath) {
    return <span className="fw-bold fs-6">Pas de pièce jointe.</span>;
  }

  const fileName = decodeURIComponent(filePath.split('/').pop().split('?')[0]);
  const fileExtension = fileName.includes('.') ? fileName.split('.').pop().toLowerCase() : '';

  const renderFileAction = (Icon, color, label) => (
    <div className="d-flex gap-3 flex-column justify-content-between">
      <div className="d-flex flex-column align-items-center gap-2">
        <Icon className="fs-1" style={{ color }} />
        <span>{fileName}</span>
      </div>
      <a
        href={filePath}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary fw-bold text-white fs-6"
        style={FILE_BUTTON_STYLE}
      >
        <span style={{ color: '#ffffff', fontWeight: 600 }}>{label}</span>
      </a>
    </div>
  );

  const renderPreview = () => {
    switch (fileExtension) {
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'webp':
      case 'bmp':
      case 'svg':
        return (
          <img
            src={filePath}
            alt={`Aperçu de ${fileName}`}
            style={{ maxWidth: '100%', maxHeight: '100%' }}
          />
        );
      case 'pdf':
        return renderFileAction(BsFileEarmarkPdfFill, '#dc3545', 'Ouvrir le fichier');
      case 'xlsx':
      case 'xls':
      case 'csv':
        return renderFileAction(BsFileEarmarkExcelFill, '#198754', 'Ouvrir le fichier');
      default:
        return renderFileAction(BsFileEarmarkFill, '#6c757d', 'Ouvrir le fichier');
    }
  };

  return <div>{renderPreview()}</div>;
}

export default FilePreview;
